import Spinner from "react-bootstrap/Spinner";
import PaginationComponent from "../../../../../component/global/PaginationComponent";
import { useEffect, useState } from "react";
import { get, post } from "../../../../../controlers/global/ConfigRequest";
import {
    COMPANY_CLUB_GROUPS,
    SHARE_GROUPS,
} from "../../../../../helperData/ApiAddress";
import { Button } from "react-bootstrap";
import Group from "./Group";
import { useTranslation } from "react-i18next";

export default function BetweenGroups({ content }) {
    const [loading, setLoading] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [groups, setGroups] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const { t } = useTranslation();

    const fetchGroups = () => {
        setLoading(true);
        get(COMPANY_CLUB_GROUPS.replace("{id}/", currentPage))
            .then((r) => {
                setGroups(r.results);
                setPageCount(r.lastPage);
            })
            .finally((e) => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchGroups();
    }, [currentPage]);

    const shareHandle = () => {
        setSendLoading(true);
        post(SHARE_GROUPS, {
            content,
            groups: selectedGroups,
        }).finally((r) => {
            setSelectedGroups([]);
            setSendLoading(false);
        });
    };

    return (
        <>
            <div className="table">
                <div className="group-grid">
                    {loading === false ? (
                        groups.length > 0 ? (
                            groups.map((group, index) => (
                                <Group
                                    data={group}
                                    selectedGroups={selectedGroups}
                                    setSelectedGroups={setSelectedGroups}
                                    key={index}
                                />
                            ))
                        ) : (
                            <div>
                                {t(
                                    "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.BetweenUsers.NothingFound.Label"
                                )}
                            </div>
                        )
                    ) : (
                        <Spinner animation="border" />
                    )}
                </div>
            </div>
            <div className="pagination">
                <PaginationComponent
                    pageCount={pageCount}
                    key={currentPage}
                    fetchData={(e) => console.log(e)}
                    currentPage={currentPage - 1}
                    setCurrentPage={(e) => setCurrentPage(e + 1)}
                    feedbacks={4}
                />
                <div className="button-box">
                    <Button
                        onClick={shareHandle}
                        className="form_btn medium blue"
                        disabled={selectedGroups.length === 0}
                    >
                        {sendLoading ? (
                            <Spinner animation="border" />
                        ) : (
                            <span>
                                {t(
                                    "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.BetweenUsers.Sharing"
                                )}
                            </span>
                        )}
                    </Button>
                </div>
            </div>
        </>
    );
}
